import axios from 'axios';
import { GET_FEATURE_PRICE } from './constants';

export function getFeaturePrice(data, params) {
  return axios
    .post(GET_FEATURE_PRICE, data, { params, withCredentials: true })
    .catch(() => ({}));
}
